'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$91() {
  this.c30 = null;
  this.c31 = false;
}
export { $c_Lpresto_types$$anon$91 as $c_Lpresto_types$$anon$91 };
$p = $c_Lpresto_types$$anon$91.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$91;
/** @constructor */
function $h_Lpresto_types$$anon$91() {
}
export { $h_Lpresto_types$$anon$91 as $h_Lpresto_types$$anon$91 };
$h_Lpresto_types$$anon$91.prototype = $p;
$p.P = (function() {
  if ((!this.c31)) {
    this.c30 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.c31 = true;
  }
  return this.c30;
});
var $d_Lpresto_types$$anon$91 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$91, "presto.types$$anon$91", ({
  Yg: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_types$$anon$91 as $d_Lpresto_types$$anon$91 };
//# sourceMappingURL=presto.types$$anon$91.js.map
